import { Image, Modal, Text, Title, ActionButton } from "components/commons";
import React from "react";
import styles from "./success-modal.module.scss";
import locale from "localization";
import { CarFormSuccess } from "images";

const SuccessModal = ({
  title,
  content = "",
  image = CarFormSuccess,
  primary,
  secondary,
  contentHighlight = [],
  centerButtons,
  loading,
  ...state
}) => {
  const {
    text: primaryText = "Got It",
    onClick: primaryOnClick = () => {
      state.close();
    },
  } = primary || {};

  const {
    text: secondaryText = "Cancel",
    onClick: secondaryClick = () => {
      state.close();
    },
  } = secondary || {};

  const shouldCenter = centerButtons !== undefined ? centerButtons : !secondary;

  return (
    <Modal {...state}>
      <div className={styles.container}>
        <Image src={image} className={styles.image} />
        <Title small className={styles.title}>
          {title}
        </Title>
        <Text className={styles.content}>
          <locale.Populate text={content} items={contentHighlight} />
        </Text>
      </div>
      <ActionButton
        center={shouldCenter}
        right={!shouldCenter}
        loading={loading ?? false}
        items={[
          ...(secondary
            ? [
                {
                  onClick: () => {
                    secondaryClick();
                    state.close();
                  },
                  text: secondaryText,
                  primary: false,
                },
              ]
            : []),
          {
            onClick: () => {
              primaryOnClick();
            },
            text: primaryText,
            primary: true,
          },
        ]}
      />
    </Modal>
  );
};

export default SuccessModal;
